import { createBrowserRouter } from 'react-router-dom';
import NotFound from './NotFound';

export const homeDipropneuRouter = createBrowserRouter([
  {
    path: '/',
    lazy: () => import("./Layout").then(m => ({ Component: m.Layout })),
    children: [
      {
        index: true,
        lazy: () => import("./pages/HomePage").then(m => ({ Component: m.HomePage })),
      },
      {
        path: '*',
        element: <NotFound />,
      }
    ]
  }
]);